/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DateTimeTTLOCriteriaRangeRequest,
    DateTimeTTLOCriteriaRangeRequestFromJSON,
    DateTimeTTLOCriteriaRangeRequestFromJSONTyped,
    DateTimeTTLOCriteriaRangeRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface TTLOTravelDateRange
 */
export interface TTLOTravelDateRange {
    /**
     * 
     * @type {DateTimeTTLOCriteriaRangeRequest}
     * @memberof TTLOTravelDateRange
     */
    range?: DateTimeTTLOCriteriaRangeRequest;
    /**
     * 
     * @type {number}
     * @memberof TTLOTravelDateRange
     */
    order?: number;
}

export function TTLOTravelDateRangeFromJSON(json: any): TTLOTravelDateRange {
    return TTLOTravelDateRangeFromJSONTyped(json, false);
}

export function TTLOTravelDateRangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TTLOTravelDateRange {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'range': !exists(json, 'range') ? undefined : DateTimeTTLOCriteriaRangeRequestFromJSON(json['range']),
        'order': !exists(json, 'order') ? undefined : json['order'],
    };
}

export function TTLOTravelDateRangeToJSON(value?: TTLOTravelDateRange | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'range': DateTimeTTLOCriteriaRangeRequestToJSON(value.range),
        'order': value.order,
    };
}


